module.exports = __webpack_public_path__ + "static/media/more-btn.3840cb9c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/more-btn.webp
// module id = 276
// module chunks = 0